import { render, staticRenderFns } from "./TemplateFilters.vue?vue&type=template&id=a5de27c2"
import script from "./TemplateFilters.vue?vue&type=script&lang=ts"
export * from "./TemplateFilters.vue?vue&type=script&lang=ts"
import style0 from "./TemplateFilters.vue?vue&type=style&index=0&id=a5de27c2&prod&lang=scss&module=true"
import style1 from "./TemplateFilters.vue?vue&type=style&index=1&id=a5de27c2&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports